export default (inletElement: HTMLElement): object => {
  return JSON.parse(inletElement.getAttribute('params') || inletElement.getAttribute('data-params') || '{}')
}
